import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';
import { AutomationRuleApiService } from '../automation-rule-api.service';
import { AutomationRule } from '../../model/automation-rule.model';
import {
  CreateRule,
  DeleteRule,
  LoadRules,
  UpdateRule,
} from './automation-rule.actions';

export interface AutomationRulesStateModel {
  rules: AutomationRule[];
  total: number;
}

@State<AutomationRulesStateModel>({
  name: 'automationRules',
  defaults: {
    rules: [],
    total: 0,
  },
})
@Injectable()
export class AutomationRulesState {
  private readonly api = inject(AutomationRuleApiService);

  @Selector()
  static getRules(state: AutomationRulesStateModel): AutomationRule[] {
    return state.rules;
  }

  @Selector()
  static getTotal(state: AutomationRulesStateModel): number {
    return state.total;
  }

  @Action(LoadRules)
  loadRules(
    ctx: StateContext<AutomationRulesStateModel>,
    { page, maxResults }: LoadRules,
  ) {
    return this.api.getRules(page, maxResults).pipe(
      tap((response) =>
        ctx.patchState({
          rules: response.rules,
          total: response.meta.totalRecords,
        }),
      ),
    );
  }

  @Action(CreateRule)
  createRule(
    _ctx: StateContext<AutomationRulesStateModel>,
    { payload }: CreateRule,
  ) {
    return this.api.createRule(payload);
  }

  @Action(UpdateRule)
  updateRule(
    _ctx: StateContext<AutomationRulesStateModel>,
    { id, payload }: UpdateRule,
  ) {
    return this.api.updateRule(id, payload);
  }

  @Action(DeleteRule)
  deleteRule(
    _ctx: StateContext<AutomationRulesStateModel>,
    { id }: DeleteRule,
  ) {
    return this.api.deleteRule(id);
  }
}
